var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabState = function SvgTabState(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon_1_",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "figure",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.969-.031c-8.836 0-16 7.163-16 16s7.164 16 16 16 16-7.163 16-16-7.164-16-16-16m-.031 25.062a9.063 9.063 0 1 1 0-18.127 9.063 9.063 0 0 1 0 18.127",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "_x31_4",
    cx: 15.969,
    cy: 15.938,
    r: 7.063,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabState);
export default ForwardRef;